import Migration from './migration'

import Logger from '@/logger'

export default class M004 extends Migration {

    constructor() {
        super('M004 - Clear Non-context Storage',
            async(authContext) => {
                try {
                    await this.removeAsync('selected-property')
                    await this.removeAsync('selected-property', authContext)
                    await this.removeAsync('preferences')
                    await this.removeAsync('preferences', authContext)

                    Logger.log('Locally stored property and preferences data cleared', 'Migrations')
                } catch {
                    Logger.log('No project data to clear', 'Migrations')
                }
            })
    }
}
